import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

export class RequiredField extends Component {

  render() {
    const { name } = this.props
    return (
      <React.Fragment>
        <span>{name}</span>
        <span style={{ color: 'red' }} >&nbsp;*</span>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(RequiredField)))